import { render } from "./NewBenchmarkingAnalysisModal.vue?vue&type=template&id=3e35845a"
import script from "./NewBenchmarkingAnalysisModal.vue?vue&type=script&lang=js"
export * from "./NewBenchmarkingAnalysisModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__